export default "__VITE_ASSET__DVyjOnkd__"